import { AD_TYPE, VEHICLE_TYPE } from '@/utils/constants'
import { getValueFormatted, roundPrice, getItemUrl, userPiiLead, userPiiLocation } from '@/utils/utils'
import { Math } from 'window-or-global'

const DEFAULT_VALUES_LAYER = {
  site: {
    domain: 'www.webmotors.com.br',
    country: 'brasil',
    server: 'web',
    environment: 'comprar',
    subEnvironment: 'comprar',
    tmsVersion: undefined,
    clientType: 'pf',
    platform: 'desktop',
    brandOrigin: 'webmotors',
  },
  page: {
    flowType: 'fluxo-comprar',
    url: null,
    pageNameTier1: 'comprar',
    trackingCode: {
      idcmp: null,
      idcmpint: null,
      icid: null,
      lkid: null,
    },
  },
  user: {
    pii: {
      lead: {
        email: userPiiLead().email,
        name: userPiiLead().name,
        phoneNumber: userPiiLead().phoneNumber
      },
      location: {
        optin: {
          state: userPiiLocation().state,
          city: userPiiLocation().city,
        }
      }
    }
  }
}

const getUF = State =>
  State && State.includes('(') ? State.replace(/.*\((.*)\)/, '$1') : State

const getFair = fair => {
  return fair.reduce(
    (acc, crr) => {
      const { Id, Value } = crr

      return {
        id: acc.id ? [...acc.id, Id] : [Id],
        name: acc.name ? [...acc.name, Value] : [Value],
      }
    },
    {
      id: undefined,
      name: undefined,
    }
  )
}

const createDealerObject = (detail, dealerInfo) => {
  const { Seller = {}, ProductCode } = detail.result
  const { shield } = dealerInfo?.result || {}

  const dealerFair = detail?.result?.HotDeal
    ? getFair(detail?.result?.HotDeal)
    : undefined

  const sellerIsPF =
    Seller.SellerType && Seller.SellerType.toLowerCase() === 'pf'

  const getSellerCode = sellerIsPF ? 1 : 2

  const uf = getUF(Seller.State)
  return {
    id: Seller.Id,
    location: {
      state: uf,
      city: Seller.City && Seller.State ? `${Seller.City}-${uf}` : undefined,
    },
    type: {
      id: Seller.SellerType ? getSellerCode : undefined,
      name: Seller.SellerType,
      nameDetail: Seller.AdType ? Seller.AdType.Value : undefined,
    },
    products: {
      plan: {
        id: ProductCode,
        name: undefined,
      },
      blindagem: {
        id: undefined,
        name: shield,
      },
      feirao: {
        id: dealerFair ? dealerFair.id : undefined,
        name: dealerFair ? dealerFair.name : undefined,
      },
    },
    portfolio: {
      fantasyName: Seller.FantasyName,
      rede: {
        id: undefined,
        name: undefined,
      },
      zona: {
        id: undefined,
        name: undefined,
      },
      filial: {
        id: undefined,
        name: undefined,
      },
      fidelidade: {
        id: undefined,
        name: undefined,
      },
    },
  }
}

const transformOptionsVehicle = Optionals =>
  Optionals
    ? Optionals.reduce(
        (acc, crr) => {
          const { _id, Name } = crr
          return {
            ...acc,
            ids: [...acc.ids, _id],
            names: [...acc.names, Name],
          }
        },
        { ids: [], names: [] }
      )
    : {}

const transformVehicleAttributes = (attributes = []) => {
  const availableAttributes = attributes.map(attribute => {
    return attribute.Name
  })

  const mappingAttributes = {
    ipva: availableAttributes.includes('IPVA pago') ? 1 : 2,
    license: availableAttributes.includes('Licenciado') ? 1 : 2,
    sigleOwner: availableAttributes.includes('Único dono') ? 1 : 2,
    exchange: availableAttributes.includes('Aceita troca') ? 1 : 2,
  }

  return mappingAttributes
}
const createVehicleObject = (detail, options) => {
  const { vehicleType, averagePrice } = options

  const { Specification, ListingType, Prices } = detail
  const isNewVehicle = ListingType === AD_TYPE.NEW
  const isCar = vehicleType === VEHICLE_TYPE.car
  const vehiclePrice = Prices ? parseFloat(Prices.Price) : undefined
  const fipePrice = averagePrice ? averagePrice.FipePrice : undefined

  const optionals = transformOptionsVehicle(Specification.Optionals)
  const isArmored = Specification.Armored === 'S'

  const vehicleAttributes = transformVehicleAttributes(
    Specification.VehicleAttributes
  )

  const fipeVariance =
    vehiclePrice && fipePrice
      ? parseFloat((vehiclePrice / fipePrice).toFixed(2))
      : undefined

  const lifeStyleExists =
    Specification.LifeStyle && Specification.LifeStyle.length

  const categories = lifeStyleExists
    ? Specification.LifeStyle.map(category => category.Value)
    : undefined

  return {
    condition: {
      id: isNewVehicle ? 2 : 1,
      name: isNewVehicle ? 'novo' : 'usado',
    },

    type: {
      id: isCar ? 1 : 2,
      name: isCar ? 'Carro' : 'Moto',
    },

    make: {
      id:
        Specification && Specification.Make
          ? getValueFormatted(Specification.Make.id)
          : undefined,
      name:
        Specification && Specification.Make
          ? getValueFormatted(Specification.Make.Value)
          : undefined,
    },

    model: {
      id:
        Specification && Specification.Model
          ? getValueFormatted(Specification.Model.id)
          : undefined,
      name:
        Specification && Specification.Model
          ? getValueFormatted(Specification.Model.Value)
          : undefined,
    },

    modelVersion: {
      id: undefined,
      name: undefined,
    },

    version: {
      id:
        Specification && Specification.Version
          ? getValueFormatted(Specification.Version.id)
          : undefined,
      name:
        Specification && Specification.Version
          ? getValueFormatted(Specification.Version.Value)
          : undefined,
    },

    kilometre: {
      value: Specification.Odometer
        ? parseFloat(Specification.Odometer)
        : undefined,
      rounded: Specification.Odometer
        ? roundPrice(Specification.Odometer)
        : undefined,
      tier: undefined,
    },
    optional: {
      id: optionals.ids,
      name: optionals.names,
    },

    gearshift: {
      id: undefined,
      name:
        Specification && Specification.Transmission
          ? getValueFormatted(Specification.Transmission)
          : '',
    },

    finalPlate: {
      id: undefined,
      name: Specification.FinalPlate,
      rotation: undefined,
    },
    armor: {
      id: isArmored ? 1 : 2,
      name: isArmored ? 'blindado' : 'nao-blindado',
    },

    color: {
      id: Specification.Color.IdPrimary,
      name: Specification.Color.Primary,
    },

    bodyType: {
      id: undefined,
      name:
        Specification && Specification.BodyType
          ? Specification.BodyType
          : undefined,
    },
    year: {
      model: {
        value: parseInt(Specification.YearModel, 10),
        tier: undefined,
      },
      manufacture: {
        value: Specification.YearFabrication,
        tier: undefined,
      },
    },
    yearFuel: {
      id: undefined,
      name: undefined,
    },
    price: {
      vehicle: {
        value: vehiclePrice,
        rounded: vehiclePrice ? roundPrice(vehiclePrice) : undefined,
        tier: undefined,
      },
      fipe: {
        value: fipePrice || undefined,
        rounded: roundPrice(fipePrice) || undefined,
        tier: undefined,
      },
      fipeVariance: {
        value: fipeVariance,
        rounded: fipeVariance ? Math.round(fipeVariance) : undefined,
        tier: undefined,
      },
    },
    fuel: {
      id: undefined,
      name: Specification.Fuel,
    },
    category: {
      id: undefined,
      name: categories,
    },
    ipva: vehicleAttributes.ipva,
    license: vehicleAttributes.license,
    singleOwner: vehicleAttributes.sigleOwner,
    exchange: vehicleAttributes.exchange,
  }
}

const createSearchObject = search => {
  const { search: query } = window.location
  const {
    location = {},
    ordination = {},
    vehicle = {},
    cardExhibition = {},
    pageNumber,
    totalResults,
    eventType,
  } = search

  const actionCode = {
    ordenacaoRealizada: 4,
    paginacaoRealizada: 3,
    buscaRealizada: 1,
    filtroRealizado: 2,
  }

  return {
    pageNumber,
    listItens: {
      totalResults,
    },
    location: {
      city: location.city,
      state: location.state,
    },
    ordination: {
      id: ordination.id,
      name: ordination.name,
    },
    openSearch: {
      writtenTerm: getItemUrl(query, 'autocomplete'),
      autoCompleteTerm: getItemUrl(query, 'autocompleteTerm'),
    },
    vehicle: {
      type: {
        id: vehicle.type ? vehicle.type.id : undefined,
        name: vehicle.type ? vehicle.type.name : undefined,
      },
    },
    cardExhibition: {
      id: cardExhibition.id,
      name: cardExhibition.name,
    },
    action: {
      id: actionCode[eventType],
      name: eventType,
    },
  }
}

const createListItensObject = ads => {
  if (!ads) {
    return []
  }

  const listItens = ads.map(ad => ({
    ad: {
      id: ad.UniqueId,
    },
    dealer: {
      id: ad.Seller?.Id,
    },
  }))

  return listItens
}

export default DEFAULT_VALUES_LAYER
export {
  createDealerObject,
  createSearchObject,
  createListItensObject,
  createVehicleObject,
}
